if (!customElements.get('vwd-shipping')) {
  customElements.define('vwd-shipping', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.country = this.form.elements.country;
      this.province = this.form.elements.province;
      this.results = this.querySelector('[role="status"]');
      this.button = this.querySelector('[type="submit"]');
      this.buttonLabel = this.button.querySelector('[data-estimate-label]');
      this.country.value = 'United States';
      this.country.addEventListener('change', () => this.setProvinces());
      this.form.addEventListener('change', event => {
        if (event.target.tagName === 'SELECT') this.invalidate();
      });
      this.form.addEventListener('input', () => this.invalidate());
      this.form.addEventListener('submit', event => { event.preventDefault(); this.estimate(); });
      this.onCartChange = () => this.refresh();
      document.addEventListener('vwd:cart-updated', this.onCartChange);
      this.setProvinces();
      this.setupModal = () => {
        if (!this.isConnected || this.modal) return;
        this.modal = new window.Modals('vwd-shipping-modal', 'vwd-shipping', {
          open: '[data-vwd-modal-anchor]', focusOnOpen: 'vwd-shipping-country'
        });
        this.policyModal = new window.Modals('vwd-shipping-policy-modal', 'vwd-shipping-policy', {
          open: '[data-vwd-policy-anchor]', focusOnOpen: 'vwd-shipping-policy-title'
        });
        this.onOpen = event => {
          const policyTrigger = event.target.closest('[data-vwd-policy-open]');
          if (policyTrigger) {
            this.modal.closeModal();
            this.policyModal.openElement = policyTrigger;
            this.policyModal.open(event);
            return;
          }
          const trigger = event.target.closest('[data-vwd-shipping-open]');
          if (!trigger) return;
          this.policyModal.closeModal();
          this.modal.openElement = trigger;
          this.modal.open(event);
        };
        document.addEventListener('click', this.onOpen);
        this.querySelector('#vwd-shipping-policy-modal').addEventListener('click', event => {
          if (event.target === event.currentTarget) this.policyModal.closeModal();
        });
        this.querySelector('#vwd-shipping-modal').addEventListener('click', event => {
          if (event.target === event.currentTarget) this.modal.closeModal();
        });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.setupModal, { once: true });
      else this.setupModal();
    }
    disconnectedCallback() {
      document.removeEventListener('vwd:cart-updated', this.onCartChange);
      document.removeEventListener('DOMContentLoaded', this.setupModal);
      document.removeEventListener('click', this.onOpen);
      this.modal?.closeModal();
      this.policyModal?.closeModal();
      this.controller?.abort();
    }
    invalidate() {
      this.controller?.abort();
      this.controller = null;
      this.results.textContent = '';
      this.button.disabled = false;
      if (this.buttonLabel.textContent !== 'Get estimate') this.buttonLabel.textContent = 'Get estimate';
    }
    setProvinces() {
      const provinces = JSON.parse(this.country.selectedOptions[0]?.dataset.provinces || '[]');
      this.province.replaceChildren(...provinces.map(([value, label]) => new Option(label, value)));
      this.querySelector('[data-province-label]').hidden = !provinces.length;
      if (this.country.value === 'United States') this.province.value = 'Indiana';
    }
    refresh() {
      this.invalidate();
      this.modal?.closeModal();
      this.policyModal?.closeModal();
    }
    async estimate() {
      this.invalidate();
      const controller = new AbortController();
      this.controller = controller;
      this.button.disabled = true;
      this.buttonLabel.textContent = 'Checking rates…';
      this.results.textContent = 'Checking shipping rates for your cart…';
      const params = new URLSearchParams({
        'shipping_address[country]': this.country.value,
        'shipping_address[province]': this.province.value,
        'shipping_address[zip]': this.form.elements.zip.value.trim()
      });
      const timeout = setTimeout(() => controller.abort(), 30000);
      try {
        const response = await fetch(this.dataset.cartUrl + '/shipping_rates.json?' + params, { signal: controller.signal });
        const data = await response.json();
        if (!response.ok) {
          const errors = Object.entries(data).map(([key, value]) => key.replaceAll('_', ' ') + ': ' + (Array.isArray(value) ? value.join(', ') : value));
          throw new Error(errors.join('. ') || 'Please check your destination and try again.');
        }
        this.results.replaceChildren();
        if (!data.shipping_rates?.length) {
          this.results.textContent = 'No shipping rates were returned for this destination. Check your address or contact us for help.';
          return;
        }
        const heading = document.createElement('strong');
        heading.textContent = 'Estimated shipping rates';
        const list = document.createElement('ul');
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency });
        data.shipping_rates.forEach(rate => {
          const row = document.createElement('li');
          row.textContent = rate.name + ': ' + money.format(Number(rate.price));
          list.append(row);
        });
        this.results.append(heading, list);
      } catch (error) {
        if (this.controller !== controller) return;
        this.results.textContent = error.name === 'AbortError' ? 'The rate request timed out. Please try again.' : (error.message === 'Failed to fetch' ? 'Unable to retrieve rates. Please try again.' : error.message);
      } finally {
        clearTimeout(timeout);
        if (this.controller === controller) {
          this.button.disabled = false;
          if (this.buttonLabel.textContent !== 'Get estimate') this.buttonLabel.textContent = 'Get estimate';
        }
      }
    }
  });
}
